<template>
    <div>
        <div>
            Are you sure you want to remove <span class="font-medium">{{ data?.file_name }}</span
            >?
        </div>
        <DocumentExpiryDeleteOption
            v-model="cancelExpiry"
            :file="data"
        />
        <div class="mt-4 flex flex-col justify-end gap-2 md:flex-row">
            <MuvalButton
                cancelBtn
                class="order-2 md:order-1"
                type="button"
                @click.prevent="emit('cancel:modal')"
            >
                Cancel
            </MuvalButton>
            <MuvalButton
                :loading="loading"
                class="order-1 md:order-2"
                @click.prevent="handleDelete()"
            >
                Remove
            </MuvalButton>
        </div>
    </div>
</template>

<script setup>
import DocumentExpiryDeleteOption from '@components/company-diary/DocumentExpiryDeleteOption.vue';
const cancelExpiry = ref(false);
const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
    url: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['cancel:modal', 'close:modal']);

const loading = ref(false);

async function handleDelete() {
    loading.value = true;
    await window.tenantAxios.delete(`${props.url}/${props.type}/${props.data.id}`, {
        params: { cancel_expiry: cancelExpiry.value ? 1 : 0 },
    });
    loading.value = false;
    emit('close:modal');
}
</script>
